<script setup lang="ts">
import { NuxtLink } from "#components";

const props = defineProps<{
  label?: string;
  content?: string | { content?: string; link?: string }[];
  link?: string;
}>();

const links = computed(() => {
  if (Array.isArray(props.content)) {
    return props.content;
  }

  return [{ content: props.content, link: props.link }];
});

const { isExternalLink } = useLinks();
</script>

<template>
  <div class="post-content-details-item">
    <div class="post-content-details-item__wrapper">
      <div
        :class="[
          'post-content-details-item__label',
          'flex items-center justify-start gap-4 flex-wrap',
          'text-xs leading-[0.875rem]',
          'text-[#242020]',
          '',
          'mb-[0.375rem]',
        ]"
      >
        <p class="post-content-details-item__label-wrapper">
          <span>{{ label }}</span>
        </p>
      </div>

      <div
        :class="[
          'post-content-details-item__content',
          'flex items-center justify-start gap-4 flex-wrap',
          'text-sm leading-[0.875rem]',
          'text-[#242020]',
        ]"
      >
        <component
          v-for="{ link, content } in links"
          :is="link ? NuxtLink : 'div'"
          :href="link ? link : undefined"
          :target="isExternalLink(link) ? '_blank' : undefined"
          :rel="isExternalLink(link) ? 'nofollow noopener' : undefined"
          :class="[{ underline: link }]"
        >
          <span>{{ content }}</span>
        </component>
      </div>
    </div>
  </div>
</template>
